<div [ngClass]="'container ' + data.type" fxLayout="column" fxLayoutGap="32px" fxLayoutAlign="center center">
  <div [ngClass]="'icon ' + data.type">
    <mat-icon>{{data.type == 'success' ? 'check_circle' : 'error'}}</mat-icon>
  </div>
  <span [ngClass]="'message ' + data.type">{{data.msg}}</span>
  
  <span [ngClass]="'obs ' + data.type">{{data.obs}}</span>


  <button mat-flat-button class="submit-button" (click)="close()">{{data.confirm && !data.showOk ? 'CONFIRMAR' : 'OK'}}</button>
</div>